import { Typography } from "antd";

const { Text } = Typography;

/**
 * Label-above-value block used by the course linking dashboards to keep every
 * field readable when the row collapses into a stacked grid on small screens.
 *
 * @param {Object} props
 * @param {string} props.label - Field name rendered above the value.
 * @param {React.ReactNode} props.children - Rendered field value.
 */
const LinkedEntityField = ({ label, children }) => (
  <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
    <Text type="secondary" style={{ fontSize: "11px" }}>
      {label}
    </Text>
    {children}
  </div>
);

export default LinkedEntityField;
